export default "__VITE_ASSET__MvFPyYO9__"